"use client";

import { c as _c } from "react/compiler-runtime";
import A11y from "assets/icons/a11y.svg";
import HighContrastSaturation from "assets/icons/high-contrast-saturation.svg";
import Saturation from "assets/icons/saturation.svg";
import { fontSizeButtons } from "components/A11yControls/helpers";
import type { A11yControlsProps } from "components/A11yControls/types";
import { useA11ySettings } from "components/A11yControls/useA11yControls";
import { useIntl } from "react-intl";
import { DropdownMenu } from "ui/DropdownMenu";
import { cn } from "utils/helpers/cn";
const dropdownItemStyles = cn("p-n2 flex align-center gap-n4 first:text-normal text-f-primary");
function A11yDropdownMenu(t0) {
  const $ = _c(41);
  const {
    variant
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const {
    toggleHighContrast,
    setFontSize,
    isHighContrast
  } = useA11ySettings();
  const t1 = variant === "simple";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("a11y__dropdown", "pr-n4", {
      "p-0": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = variant === "simple";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("rounded-nlg border border-gray2 bg-white p-n2 shadow-controls", {
      "border-0 bg-transparent p-0 shadow-none": t3
    }, "dark: 'dark: border-background shadow-none dark:bg-background");
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== formatMessage) {
    t5 = formatMessage({
      id: "a11y_settings"
    });
    $[4] = formatMessage;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <A11y className="dark:fill-font-1" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5) {
    t7 = <DropdownMenu.Trigger><button type="button" data-test-id="dropdown-button" className={t4} aria-label={t5}>{t6}</button></DropdownMenu.Trigger>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("a11y__dropdown__content", "mr-n4 rounded-3xl bg-white p-n4 shadow-controls", "dark: shadow-none dark:bg-background");
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== formatMessage || $[12] !== setFontSize) {
    t9 = fontSizeButtons.map(t10 => {
      const {
        value,
        label,
        textSize
      } = t10;
      return <DropdownMenu.Item key={value} onSelect={() => setFontSize(value)} title={formatMessage({
        id: label
      })} aria-label={formatMessage({
        id: label
      })} data-test-id={`button-font-size-${value}`} className={dropdownItemStyles}><span style={{
          fontSize: textSize
        }}>A</span><span>{formatMessage({
            id: label
          })} </span></DropdownMenu.Item>;
    });
    $[11] = formatMessage;
    $[12] = setFontSize;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== formatMessage) {
    t10 = formatMessage({
      id: "high_contrast"
    });
    $[14] = formatMessage;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== formatMessage) {
    t11 = formatMessage({
      id: "high_contrast"
    });
    $[16] = formatMessage;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== toggleHighContrast) {
    t12 = () => toggleHighContrast();
    $[18] = toggleHighContrast;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isHighContrast) {
    t13 = isHighContrast ? <HighContrastSaturation /> : <Saturation />;
    $[20] = isHighContrast;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== formatMessage) {
    t14 = formatMessage({
      id: "high_contrast"
    });
    $[22] = formatMessage;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <span>{t14}</span>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t15) {
    t16 = <DropdownMenu.Item data-test-id="button-contrast" title={t10} aria-label={t11} onSelect={t12} className={dropdownItemStyles}>{t13}{t15}</DropdownMenu.Item>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t9) {
    t17 = <DropdownMenu.Content className={t8} sideOffset={5} side="bottom">{t9}{t16}</DropdownMenu.Content>;
    $[32] = t16;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17 || $[36] !== t7) {
    t18 = <DropdownMenu>{t7}{t17}</DropdownMenu>;
    $[35] = t17;
    $[36] = t7;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18 || $[39] !== t2) {
    t19 = <div className={t2}>{t18}</div>;
    $[38] = t18;
    $[39] = t2;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
}
export default A11yDropdownMenu;